export default __webpack_public_path__ + "static/media/marker-logo.32c9bfb2.svg";